import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../../theme';
import { blindedBlock } from '../shipmentDetailShared.styles';
import addressPlaceholder from '../../../resources/img/address-placeholder.png';
import flightsPlaceholder from '../../../resources/img/flights-placeholder.png';

export const useShipmentOrderSummaryStyles = createStyles(({ token }) => ({
  // `&&` self-doubles so these deterministically outrank
  // typography.styles.js's `commonLabelValueLabel`/`commonLabelValueText`
  // (equal specificity otherwise, applied compound on the same element —
  // the winner would depend on unpredictable hook-injection order).
  airlineLabel: {
    '&&': {
      lineHeight: '16px',
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    },
  },
  airlineText: {
    '&&': {
      lineHeight: '16px',
      fontWeight: 500,
    },
  },
  airlineTextMedium: {
    '&&': {
      fontSize: token.fontSize,
    },
  },
  airlineTextSmall: {
    '&&': {
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    },
  },
  airlineLabelDiv: {
    '&&': {
      fontSize: ThemeFont.FONT_SIZE_XS,
      fontWeight: 500,
    },
  },
  airlineTextLarge: {
    '&&': {
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
      fontWeight: 'bold',
    },
  },
  indentLeft: {
    marginLeft: ThemeSpaces.SPACE_XS,
  },
  airlineSection: {
    borderBottom: `2px solid ${ThemeColors.COLOR_GREY9_5}`,
    padding: ThemeSpaces.SPACE_NORM,

    '&:last-child': {
      borderBottomWidth: 0,
    },
  },
  airlineHeader: {
    borderBottom: `2px solid ${ThemeColors.COLOR_GREY9_5}`,
    padding: `${ThemeSpaces.SPACE_NORM0_5}px ${ThemeSpaces.SPACE_SM}px`,

    '&:last-child': {
      borderBottomWidth: 0,
    },
  },
  airlineIndex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 7,
    borderRadius: '100%',
    width: 18,
    height: 18,
    border: `1px solid ${ThemeColors.COLOR_GREY_BLUISH7}`,
    backgroundImage: `linear-gradient(180deg, ${ThemeColors.COLOR_GREY_BLUISH8}, ${ThemeColors.COLOR_GREY_BLUISH7})`,
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontSize: token.fontSizeLG,
    fontWeight: 'bold',
    color: token.colorWhite,
  },
  dateLabel: {
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontWeight: 'bold',
    fontSize: ThemeFont.FONT_SIZE_XS,
    letterSpacing: '-0.15px',
    color: ThemeColors.COLOR_BLUE3,
  },
  dateValue: {
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontWeight: 'bold',
    fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    letterSpacing: '-0.2px',
  },
  blindedAddress: {
    ...blindedBlock(),
    backgroundImage: `url(${addressPlaceholder})`,
    width: 161,
    height: 112,
    paddingLeft: ThemeSpaces.SPACE_XS,
    paddingRight: ThemeSpaces.SPACE_NORM_20,
    paddingBottom: ThemeSpaces.SPACE_MD,
  },
  blindedFlights: {
    ...blindedBlock(),
    backgroundImage: `url(${flightsPlaceholder})`,
    width: 350,
    height: 142,
    paddingBottom: ThemeSpaces.SPACE_MD,
    justifyContent: 'center',
  },
  blindedAccountDetails: {
    ...blindedBlock(),
    padding: `${ThemeSpaces.SPACE_XS}px 0`,
    justifyContent: 'center',
  },
  deliveredStatus: {
    '.text': {
      color: ThemeColors.COLOR_BLUE2,
    },
  },
}));
